import { KeyedArray, objToKeyPairs } from "@repo/models";
import { GridPreLoaded } from "@repo/ui";
import { Column } from "@repo/ui/grid/models/column";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import AuditApi from "../../api/auditApi";
import { AuditConfig } from "../../models";
import { Props } from "./types";

const defaultColumns = [
	new Column("Name", "name"),
	new Column("Email", "email"),
	new Column("Active", "active").withBooleanFormat("Active", "Inactive"),
] as Column<AuditConfig>[];

export async function loadConfig(code: string) {
	const configs = await AuditApi.loadConfigs(code);

	configs.forEach((c) => {
		const parsedValues = JSON.parse(c.paramValues as any);
		c.paramValues = objToKeyPairs(parsedValues);
	});

	return new KeyedArray<AuditConfig>(configs, (b) => b.id);
}

function AuditConfigGrid(props: Props) {
	const configQuery = useQuery({
		queryKey: ["Configs", props.code],
		queryFn: () => loadConfig(props.code),
	});

	const [columns, setColumns] = useState(defaultColumns);

	const nameFormat = (a: string | undefined) => a ?? props.definition;

	useEffect(() => {
		columns[0].withFormat(nameFormat);
		setColumns([...columns]);
	}, [props.definition]);

	function onClickRow(id: number) {
		props.onClickRow(configQuery.data.get(id));
	}

	return (
		<section id="configSelector">
			<GridPreLoaded<AuditConfig>
				values={configQuery.data?.data ?? []}
				sortable
				getData={() => configQuery.refetch()}
				columns={columns}
				onClickRow={onClickRow}
				keyProperty="id"
				loading={!configQuery.isFetched}
			/>
		</section>
	);
}

export default AuditConfigGrid;
